import React from 'react';

import { Button } from '../../components/Button/Button';
import { useInView } from '../../hooks/useInView';
import type { FinalCta } from './types';

import './FinalCtaSection.css';

type FinalCtaSectionProps = {
    data: FinalCta;
};

export function FinalCtaSection({ data }: FinalCtaSectionProps) {
    const [ref, inView] = useInView<HTMLDivElement>();

    return (
        <section className="programs-final">
            <img
                className="programs-final__bg"
                src={data.backgroundImage}
                alt=""
                aria-hidden="true"
            />
            <div className="programs-final__overlay" aria-hidden="true" />
            <div
                ref={ref}
                className={`programs-final__copy faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
            >
                <h2 className="programs-final__heading faves-reveal">{data.heading}</h2>
                <Button
                    label={data.cta.label}
                    href={data.cta.href}
                    variant="accent"
                    className="programs-final__cta faves-reveal"
                />
                <span className="programs-final__note faves-reveal">{data.note}</span>
            </div>
        </section>
    );
}
